import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';
import GoogleMapsComponent from './GoogleMapsComponent.js'

class Way extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card borderNone">
                          <div className="card-body">
                            <h5 className="card-title">Anfahrt</h5>
                            <h6 className="card-subtitle mb-2 text-muted"></h6>
                            <p>
                            Inselstra&szlig;e 11, 40479 D&uuml;sseldorf
                            </p>
                            <p className="card-text">
                                <GoogleMapsComponent isMarkerShown />
                            </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Way;


// WEBPACK FOOTER //
// ./src/Way.js